import * as React from "react";

import { isAuthenticated } from "@needl-ai/common/auth/auth";
import {
  isICRAResearchAssist,
  isMSquaredHub,
} from "@needl-ai/common/utils/isEnv";

const MAIN_APP_LOGIN_URL = `${import.meta.env.VITE_MAIN_URL}/auth/signin`;
const ICRA_RESEARCH_ASSIST_HOME_PAGE = import.meta.env.VITE_MAIN_URL;

const ProtectedRoute = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element | null => {
  const [isUserAuthenticated, setIsUserAuthenticated] = React.useState<
    boolean | undefined
  >();

  React.useEffect(() => {
    (async () => {
      const result = await isAuthenticated();
      setIsUserAuthenticated(result);
    })();
  }, []);

  const redirectToMainAppLogin = () => {
    if (isMSquaredHub()) {
      window.location.href = window.location.origin;
    } else if (isICRAResearchAssist()) {
      window.location.href = ICRA_RESEARCH_ASSIST_HOME_PAGE;
    } else {
      window.location.href = MAIN_APP_LOGIN_URL;
    }
  };

  if (isUserAuthenticated === undefined) return null;

  if (!isUserAuthenticated) {
    redirectToMainAppLogin();
    return null;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
